/** Public funnel API — no auth; calls get-funnel / submit-funnel edge functions. */

const SUPABASE_PROJECT_URL =
  import.meta.env.VITE_SUPABASE_URL || 'https://ogxgxzvxbmnszfxbiuai.supabase.co';

export const FUNNEL_FUNCTIONS_BASE = `${SUPABASE_PROJECT_URL.replace(/\/$/, '')}/functions/v1`;

export const GO_FUNNEL_BASE = 'https://go.prosperityleaders.net';

export function getFunnelLiveUrl(slug, stepSlug = null) {
  if (!slug) return null;
  const path = stepSlug ? `/${slug}/${stepSlug}` : `/${slug}`;
  return `${GO_FUNNEL_BASE}${path}`;
}

/** Build in-app route path with preserved UTM params. */
export function buildFunnelPath(slug, stepSlug, searchParams) {
  const base = stepSlug ? `/go/${slug}/${stepSlug}` : `/go/${slug}`;
  const utm = extractUtmParams(searchParams);
  const qs = new URLSearchParams();
  if (utm.utm_source) qs.set('utm_source', utm.utm_source);
  if (utm.utm_medium) qs.set('utm_medium', utm.utm_medium);
  if (utm.utm_campaign) qs.set('utm_campaign', utm.utm_campaign);
  const query = qs.toString();
  return query ? `${base}?${query}` : base;
}

export function extractUtmParams(searchParams) {
  const get = (key) => searchParams?.get?.(key)?.trim() || '';
  return {
    utm_source: get('utm_source') || null,
    utm_medium: get('utm_medium') || null,
    utm_campaign: get('utm_campaign') || null,
  };
}

export async function fetchFunnel(slug, stepSlug = null) {
  const params = new URLSearchParams({ slug });
  if (stepSlug) params.set('step', stepSlug);

  const res = await fetch(`${FUNNEL_FUNCTIONS_BASE}/get-funnel?${params.toString()}`);
  const data = await res.json().catch(() => ({}));

  if (res.status === 404) {
    return { ok: false, notFound: true, error: data.error || 'Funnel not found' };
  }
  if (!res.ok) {
    return { ok: false, notFound: false, error: data.error || data.detail || 'Request failed' };
  }
  return { ok: true, data };
}

export async function submitFunnelOptin(payload) {
  const res = await fetch(`${FUNNEL_FUNCTIONS_BASE}/submit-funnel`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.error || data.detail || 'Submission failed');
  }
  return data;
}

export async function submitFunnelBooking(payload) {
  const res = await fetch(`${FUNNEL_FUNCTIONS_BASE}/submit-funnel`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ ...payload, submission_type: 'booking' }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.error || data.detail || 'Booking failed');
  }
  return data;
}

/** Resolve CTA target_step (step number) to step slug. */
export function resolveStepSlug(steps, targetStep) {
  if (targetStep == null || targetStep === '') return null;
  const num = Number(targetStep);
  const byNumber = steps?.find((s) => s.step_number === num);
  if (byNumber) return byNumber.slug;
  const bySlug = steps?.find((s) => s.slug === String(targetStep));
  return bySlug?.slug ?? null;
}

export function toVideoEmbedUrl(url) {
  if (!url) return null;
  const trimmed = url.trim();
  const ytWatch = trimmed.match(/(?:youtube\.com\/watch\?v=|youtube\.com\/watch\?.*&v=|youtu\.be\/)([\w-]+)/);
  if (ytWatch) return `https://www.youtube.com/embed/${ytWatch[1]}`;
  const vimeo = trimmed.match(/vimeo\.com\/(?:video\/)?(\d+)/);
  if (vimeo) return `https://player.vimeo.com/video/${vimeo[1]}`;
  if (trimmed.includes('/embed/') || trimmed.includes('player.vimeo.com')) return trimmed;
  return trimmed;
}
